<template>
  <div class="row">
    <div class="col-12 col-md-12 col-lg-12 col-xl-7">
      <h5 class="blue-text font-weight-bold">ユーザー一覧</h5>
    </div>
    <div class="col-12 col-md-12 col-lg-12 col-xl-5">
      <div id="table-top-ation">
        <div class="search">
          <div class="icon">
            <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'search' }" />
          </div>
          <input
            type="text"
            placeholder="検索"
            v-model="search"
            v-on:keyup="searchData"
          />
        </div>
        <router-link
          :to="{
            name: 'adminRoute-users-create',
          }"
        >
          <button
            class="btn btn-ds blue white-text add-user"
            type="button"
            v-waves.light
          >
            <font-awesome-icon
              class="mr-2"
              :icon="{ prefix: 'fas', iconName: 'add' }"
            />
            <span>管理者を追加</span>
          </button>
        </router-link>
      </div>
    </div>
    <div class="col-12 mt-4">
      <div v-if="usersData">
        <div v-if="usersData.length > 0">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th class="text-center">
                    <p class="m-0 ellipsis-1">ユーザーID</p>
                  </th>
                  <th class="text-left">
                    <p class="m-0 ellipsis-1">名前（姓）</p>
                  </th>
                  <th class="text-left">
                    <p class="m-0 ellipsis-1">名前（名）</p>
                  </th>
                  <th class="text-left">
                    <p class="m-0 ellipsis-1">メールアドレス</p>
                  </th>
                  <th class="text-left">
                    <p class="m-0 ellipsis-1">認証方法</p>
                  </th>
                  <th class="text-center">
                    <p class="m-0 ellipsis-1">権限</p>
                  </th>
                  <th class="text-left">
                    <p class="m-0 ellipsis-1">操作</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(el, i) in usersData" :key="i">
                  <td class="align-middle text-center" width="150px">
                    <p class="m-0 ellipsis-1">{{ el.id }}</p>
                  </td>
                  <td class="align-middle" width="150px">
                    <p class="m-0 ellipsis-1">
                      {{ el.last_name ? el.last_name : 'N/A' }}
                    </p>
                  </td>
                  <td class="align-middle" width="150px">
                    <p class="m-0 ellipsis-1">
                      {{ el.first_name ? el.first_name : 'N/A' }}
                    </p>
                  </td>
                  <td class="align-middle" width="200px">
                    <p class="m-0 ellipsis-1">{{ el.email }}</p>
                  </td>
                  <td class="align-middle" width="200px">
                    <p class="m-0 ellipsis-1">{{ el.is_from_google }}</p>
                  </td>
                  <td class="align-middle text-center" width="200px">
                    <p class="m-0 ellipsis-1">
                      {{ formatRole(el.role_id) }}
                    </p>
                  </td>
                  <td class="align-middle">
                    <div class="d-flex">
                      <router-link
                        :to="{
                          name: 'adminRoute-users-info',
                          params: {
                            id: el.id,
                          },
                        }"
                      >
                        <button
                          class="btn btn-ds green white-text shadow-1 w-50 mr-3 p-2 pr-4 pl-4"
                          type="button"
                          v-waves.light
                          style="min-width: 130px"
                        >
                          詳細を表示
                        </button>
                      </router-link>
                      <router-link
                        :to="{
                          name: 'adminRoute-users-edit',
                          params: {
                            id: el.id,
                          },
                        }"
                      >
                      <button
                        class="btn btn-ds amber white-text shadow-1 w-50 mr-3 p-2 pr-4 pl-4"
                        type="button"
                        v-waves.light
                        style="min-width: 130px"
                      >
                        編集
                      </button>
                      </router-link>
                      <button
                        class="btn btn-ds pink white-text shadow-1 w-50 mr-3 p-2 pr-4 pl-4"
                        type="button"
                        v-waves.light
                        style="min-width: 130px"
                        @click="showDeleteConfModal(el.id)"
                      >
                        削除
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <pagination
            class="mt-3 mb-0"
            :data="pagination.data"
            :limit="pagination.limit"
            :show-disabled="pagination.showDisabled"
            :size="pagination.size"
            :align="pagination.align"
            @pagination-change-page="paginateData"
          />
        </div>
        <div v-else>
          <b-card class="shadow-1 pt-5 pb-5 text-center" no-header no-footer>
            <img src="/img/icons/ico-info.svg" alt="ico-info" />
            <h3 class="m-0 mt-3 grey-text">表示できる内容がありません。</h3>
          </b-card>
        </div>
      </div>
      <div class="w-100" v-else>
        <div class="table-responsive">
          <table class="table w-100" striped hover>
            <thead>
              <tr>
                <th>ユーザーID</th>
                <th>名前（姓）</th>
                <th>名前（名）</th>
                <th>メールアドレス</th>
                <th>権限</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(el, i) in 15" :key="i">
                <td><b-skeleton class="mt-2"></b-skeleton></td>
                <td><b-skeleton class="mt-2"></b-skeleton></td>
                <td><b-skeleton class="mt-2"></b-skeleton></td>
                <td><b-skeleton class="mt-2"></b-skeleton></td>
                <td><b-skeleton class="mt-2"></b-skeleton></td>
                <td>
                  <div class="d-flex">
                    <b-skeleton class="w-50 mr-3" type="button"></b-skeleton>
                    <b-skeleton class="w-50 mr-3" type="button"></b-skeleton>
                    <b-skeleton class="w-50" type="button"></b-skeleton>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <b-modal
      id="user-delete-conf-modal"
      class="border-radius-2"
      size="md"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      centered
    >
      <div class="container text-center">
        <img class="mt-4" src="/img/icons/ico-info.svg" alt="ico-info" />
        <h5 class="mt-4 mb-0 dark-blue-text font-weight-bold">
          ユーザーを削除しますか
        </h5>
        <div class="row mb-3 mt-5">
          <div class="col-12">
            <button
              class="btn btn-ds dark-blue white-text pt-2 pb-2"
              type="button"
              v-waves.light
              v-on:click="deleteUser()"
            >
              はい
            </button>
            <button
              class="btn btn-ds grey white-text pt-2 pb-2 mt-5 col-md-5 col-lg-5"
              type="button"
              v-waves.light
              v-on:click="$bvModal.hide('user-delete-conf-modal')"
            >
              いいえ
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="user-delete-success-modal"
      class="border-radius-2"
      size="md"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      centered
    >
      <div class="container text-center">
        <img class="mt-4" src="/img/icons/ico-info.svg" alt="ico-info" />
        <h5 class="mt-4 mb-0 dark-blue-text font-weight-bold">
          ユーザーが削除されました
        </h5>
        <div class="row mb-3 mt-5">
          <div class="col-12">
            <button
              class="btn btn-ds dark-blue white-text pt-2 pb-2"
              type="button"
              v-waves.light
              v-on:click="$bvModal.hide('user-delete-success-modal')"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// Import Services
import { adm_userService_GetUserList, adm_userService_DeleteUser } from '../../services/admin/users';

export default {
  metaInfo() {
    return {
      title: 'Digital Staging - Dashboard',
    };
  },

  data() {
    return {
      search: '',
      usersData: null,
      pagination: {
        data: null,
        limit: 3,
        showDisabled: false,
        size: 'default',
        align: 'center',
      },
      debounce: null,
      deleteId: null,
    };
  },
  watch: {
    $route() {
      this.getResults(this.getUrlQueryParamsPage());
    },
  },
  mounted() {
    this.getResults(this.getUrlQueryParamsPage());
  },
  methods: {
    getUrlQueryParamsPage() {
      let currentRouteURLPrams = new URLSearchParams(location.search);
      return currentRouteURLPrams.get('page');
    },
    getResults(page) {
      let _this = this;

      let accessToken = localStorage.getItem('_accessToken');

      _this.usersData = null;

      adm_userService_GetUserList({
        page: page ? page : 1,
        token: accessToken,
        search: _this.search ? _this.search : '',
      })
        .then((response) => {
          let data = response.data.result;
          console.log(data);

          let filteredData = data.data.map((el) => {
            return {
              id: el.id,
              first_name: el.user_profile ? el.user_profile.first_name : null,
              last_name: el.user_profile ? el.user_profile.last_name : null,
              email: el.email,
              role_id: el.user_role ? el.user_role.role_id : null,
              is_from_google: el.is_from_google == 0 ? "パスワード" : "google",
            };
          });

          _this.usersData = filteredData;
          _this.pagination.data = data;
        })
        .catch((error) => {
          console.log(error);
        });

      _this.$store.state.currentPaginationPage = page;
    },
    paginateData(page) {
      let _this = this;
      let url_page = _this.getUrlQueryParamsPage();
      if (url_page != page) {
        _this.$router.push({
          name: 'adminRoute-users-list',
          query: { page: page },
        });
      }
    },
    searchData(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getResults();
      }, 600);
    },

    formatRole(id) {
      let role;

      switch (parseInt(id)) {
        case 1:
          role = 'Super Admin';
          break;
        case 2:
          role = 'Admin';
          break;
        case 3:
          role = 'Manager';
          break;
        case 4:
          role = 'User';
          break;
        default:
          role = 'N/A';
          break;
      }

      return role;
    },
    showDeleteConfModal(id) {
      this.deleteId = id;
      this.$bvModal.show('user-delete-conf-modal');
    },
    deleteUser() {
      let accessToken = localStorage.getItem('_accessToken');
      let id = this.deleteId;
      this.$store.state.modalLoaderMessage = '削除中';
      this.$bvModal.show('modal-loader');
      let _this = this;
    
      adm_userService_DeleteUser({
        token: accessToken,
        id: id
      })
      .then((res) => {
        console.log(res);
        this.getResults(this.getUrlQueryParamsPage());
        setTimeout(() => {
          this.$bvModal.hide('user-delete-conf-modal');
          this.$bvModal.hide('modal-loader');
          this.$bvModal.show('user-delete-success-modal');
        }, 500);
      })
      .catch((error) => {
        console.log(error);

        this.$bvToast.toast(
          'ユーザーの削除中にエラーが発生しました。再度お試しください。',
          {
            title: 'システムエラー',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: true,
          }
        );

        setTimeout(() => {
          this.$bvModal.hide('modal-loader');
        }, 500);
      });
    },
  },
};
</script>

<style scoped>
/* Init Style */
.table thead {
  background: #fff;
}

.table thead th {
  border-bottom: 0;
  color: #000;
  font-weight: bold !important;
  text-align: center;
  border-top: 0;
  font-weight: 400;
}

.table tbody td {
  border: none;
  cursor: pointer;
}

.table tbody tr {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.table tbody tr:hover {
  background: #d1d1d1;
}

/* Custom Style */
#table-top-ation {
  display: flex;
}

@media only screen and (max-width: 767px) {
  #table-top-ation {
    display: block;
  }
}

#table-top-ation .search {
  display: flex;
  margin-right: 20px;
  width: 100%;
  height: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  border: 1px solid #d1d1d1;
}

@media only screen and (max-width: 767px) {
  #table-top-ation .search {
    margin-bottom: 14px;
  }
}

#table-top-ation .search .icon {
  font-size: 24px;
  padding: 10px;
  text-align: center;
  background: #fff;
  color: #d1d1d1;
}

#table-top-ation .search input {
  width: 100%;
  border: none;
  padding: 10px;
}

#table-top-ation .search input:focus {
  outline: none;
}

#table-top-ation .add-user {
  width: 200px;
}

@media only screen and (max-width: 767px) {
  #table-top-ation .add-user {
    width: 100%;
  }
}
</style>
